import { useEffect as i } from "react";
import { useDefaultEditorOptions as l } from "../../../../RichEditor/hooks/useDefaultEditorOptions/index.js";
import { CustomLinkExtension as p } from "../../../../../adapters/quill/extensions/customLink/index.js";
import { PasteImageExtension as c } from "../../../../../adapters/quill/extensions/pasteImage/index.js";
import { PasteSimpleLinkExtension as k } from "../../../../../adapters/quill/extensions/pasteSimpleLink/index.js";
const b = ({
  defaultValue: s,
  placeholder: o,
  disabled: f,
  onHotkeySubmit: t,
  onEscKeydown: n,
  onChange: a,
  imageHandlerUpload: u
}) => {
  const m = k, { quill: r, ...d } = l({
    placeholder: o,
    readOnly: f,
    defaultValue: s,
    extensions: [
      m,
      p,
      c(u)
    ],
    onChange: a
  });
  return i(() => {
    var e;
    r && ((e = r.keyboard.bindings[13]) == null || e.unshift({
      key: 13,
      ctrlKey: !0,
      handler: () => (t(), !1)
    }));
  }, [r, t]), i(() => {
    var e;
    r && ((e = r.keyboard.bindings[13]) == null || e.unshift({
      key: 13,
      ctrlKey: !0,
      handler: () => (t(), !1)
    }));
  }, [r, t]), i(() => {
    n && (r == null || r.keyboard.addBinding({ key: "Escape", ctrlKey: !1 }, () => (n(), !0)));
  }, [r, n]), { quill: r, ...d };
};
export {
  b as useCommentInputEditor
};
